import { useEffect } from "react"
import { decodeJwt } from "../utils/Generic";
import { confirmEmail, getEmailFromOobCode } from "../services/auth";
import { useNavigate } from "react-router-dom";

const RedirectToApp = () => {
    const navigate = useNavigate()

    useEffect(() => {
        const params = new URLSearchParams(window.location.search);
        const oobCode = params.get("oobCode");
        const redirect = params.get("continueUrl")
        const mode = params.get("mode")

        if (mode == "verifyEmail") {
            confirmEmail(oobCode).then((email)=> {
                navigate('/', { state: { email: email } });
            }).catch((error)=> {
                window.location.href = "/error"
            })
        } else {
            const redirectParams = new URLSearchParams(redirect);
            const token = redirectParams.get("token")
            window.location.href = `eyeary://PasswordUpdate?oobCode=${oobCode}&email=${decodeJwt(token)?.email}&`
        }
    }, [])

    return <>You will be redirected to Eyeary app soon...</>
}

export default RedirectToApp